import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import * as Constants from 'const';
import { registerCommands } from './commands';
import { $getCharStyle } from './utils';

export { REFERENCES_FONT_COMMAND } from './commands';

export type ReferencesFontProps = {
  charStyle: Constants.CharStyle[];
};

type Props = {
  onChange: (props: ReferencesFontProps) => void;
};

export function ReferencesFontPlugin(props: Props): null {
  const { onChange } = props;
  const [editor] = useLexicalComposerContext();

  useEffect(
    () => registerCommands(editor),
    [editor],
  );

  useEffect(() => {
    const $readAndNotifyChange = (): void => onChange({
      charStyle: $getCharStyle(),
    });

    editor.getEditorState().read($readAndNotifyChange);

    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read($readAndNotifyChange);
    });
  }, [editor, onChange]);

  return null;
}
